import React from 'react';
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/uLqpiDNBisBWTYK9iUq2yM/HOMESMARTNEXT_(1).png';
interface LogoProps {
  /** `light` renders a white knockout for use on dark surfaces. */
  tone?: 'dark' | 'light';
  size?: 'sm' | 'lg';
  className?: string;
}
export function Logo({
  tone = 'dark',
  size = 'sm',
  className = ''
}: LogoProps) {
  const height = size === 'lg' ? 'h-12 md:h-16' : 'h-9 md:h-10';
  return <img src={LOGO_SRC} alt="HomeSmart NEXT" width={920} height={235} loading="eager" decoding="async" className={`w-auto ${height} ${tone === 'light' ? 'brightness-0 invert' : ''} ${className}`} data-id="element-201" data-mp="mu5va9nvxf71" />;
}